import './Input.scss';

import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import IntlCurrencyInput from "react-intl-currency-input";
import React from 'react';

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

const AppCurrencyInput = ({ label, value, onChange, name, errors, disabled = false, isRequired = false }) => {
    const inputClassName = `custom-input-focus form-control custom-input ${disabled ? 'input-disabled' : ''}`;

    return (
        <>
            <FloatingLabel
                controlId={name}
                label={<>
                    {label}
                    {isRequired && <span style={{ color: 'red' }}> *(obrigatório)</span>}
                </>}
                className="mb-3 custom-input-label"
            >
                <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    className={inputClassName}
                    value={value}
                    onChange={(event, value, maskedValue) => onChange(event, value, maskedValue)}
                />
                <Form.Control.Feedback style={{ textAlign: 'left' }} type="invalid">
                    {errors && errors[name]}
                </Form.Control.Feedback>
            </FloatingLabel>
        </>
    );
};

export default AppCurrencyInput;